import $api from "@/frontend/shared/api/axios";

export async function patchExpertAccess({
  expertId,
  portfolioCompanyIds
}: {
  expertId: number;
  portfolioCompanyIds: number[];
}) {
  return $api.patch(`/organizations/experts`, { expertId, portfolioCompanyIds });
}
